export default __webpack_public_path__ + "static/media/unchecked.d0be6943.svg";